import { useEffect, useState } from "react";
import axios from "axios";

const useTranslations = (language) => {
  const [translations, setTranslations] = useState({});
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  useEffect(() => {
    if (!language) return;

    console.log(`🔹 Çeviri API çağrısı yapılıyor: /api/translations/${language}`);

    const fetchTranslations = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/translations/${language}`);
        setTranslations(response.data || {});
      } catch (error) {
        console.error(`❌ Çeviri verileri alınamadı (${language}):`, error.message);
        setTranslations({});
      }
    };

    fetchTranslations();
  }, [language]);

  return { translations, setTranslations };
};

export default useTranslations;
